
import { FC } from "react";
import { headerPorps } from "../types";
import { ACTION_REQUIRED } from "src/constants/todos";
import GenericTableHeader from "../genericActionDashbaordHeader";

const ActionRequiredTableHeader: FC<headerPorps> = ({
  queryParam,
  changeIdOrder,
}) => {
   return (
      <GenericTableHeader queryParam={queryParam} changeIdOrder={changeIdOrder} tableHeader={ACTION_REQUIRED} />  

    );
}

export default ActionRequiredTableHeader;